import { PHASE, TIME, CHECK_ROUTINE_RESULT_TYPE } from './constants';

/** 
 * 冷却中表示
 * @param {instance} self 呼び出し元this
 * @param {string} checkRoutineData ルーチン結果確認の返り値
 */
export async function cooling(self, checkRoutineData) {
  self.isLoading = true;

  let timerInfoText, nextPhase = '';
  switch (checkRoutineData) {
    // 冷却中表示1から遷移
    case CHECK_ROUTINE_RESULT_TYPE.COOLING1:
      self.phase = PHASE.FIRST_COOLING_DISPLAY;
      timerInfoText = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_15`);
      nextPhase = PHASE.FIRST_COOLING_COMPLETED;
      break;
    // 冷却中表示2から遷移
    case CHECK_ROUTINE_RESULT_TYPE.COOLING2:
      self.phase = PHASE.SECOND_COOLING_DISPLAY;
      timerInfoText = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_17`);
      nextPhase = PHASE.SECOND_COOLING_COMPLETED;
      break;
    // 冷却中表示3から遷移
    case CHECK_ROUTINE_RESULT_TYPE.COOLING3:
      self.phase = PHASE.THIRD_COOLING_DISPLAY;
      timerInfoText = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_19`);
      nextPhase = PHASE.THIRD_COOLING_COMPLETED;
      break;
    // 通常停止から遷移
    case CHECK_ROUTINE_RESULT_TYPE.STOP:
      self.phase = PHASE.COOLING_DISPLAY;
      timerInfoText = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_7`);
      nextPhase = PHASE.INSTRUCTION_DISPLAY;
      break;
    // 中断から遷移
    case CHECK_ROUTINE_RESULT_TYPE.OTHER:
    default:
      self.phase = PHASE.INTERRUPTION_COOLING_DISPLAY;
      timerInfoText = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_11`);
      nextPhase = PHASE.COOLING_COMPLETED;
      break;
  }

  // 初期表示
  let displayTime = TIME.INITIAL_TIME_FOR_COOLING;
  self.timerInfo = timerInfoText.replace("$TIME$", Math.ceil(displayTime / 60000));

  return new Promise((resolve) => {
    self.coolingTime = setInterval(() => {
      displayTime -= TIME.INTERVAL_FOR_COOLING;
      // 指定のカウント時間が終了したら次の画面に遷移する
      if (displayTime <= 0) {
        self.isLoading = false;
        clearInterval(self.coolingTime);
        self.timerInfo = '';
        self.phase = nextPhase;
        resolve();
      }

      self.timerInfo = timerInfoText.replace("$TIME$", Math.ceil(displayTime / 60000));
    }, TIME.INTERVAL_FOR_COOLING);
  });
}

/** IG_OFF待機処理 
 * @param {instance} self 呼び出し元インスタンス
 */
export async function igOffStandby(self) {
  self.isLoading = true;

  let displayTime = TIME.INITIAL_TIME_FOR_IG_OFF;
  self.timerInfo = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_9`).replace("$TIME$", Math.ceil(displayTime / 1000));
  self.phase = PHASE.IG_OFF_STANDBY;

  self.coolingTime = setInterval(() => {
    displayTime -= TIME.INTERVAL_FOR_IG_OFF;
    // 指定のカウント時間が終了したら完了表示に遷移する
    if (displayTime <= 0) {
      self.isLoading = false;
      clearInterval(self.coolingTime);
      self.timerInfo = '';
      self.phase = PHASE.SUCCESS;
    }

    self.timerInfo = self.$t(`${self.i18nWsKey}.REQ_WS_158_TXT_9`).replace("$TIME$", Math.ceil(displayTime / 1000));
  }, TIME.INTERVAL_FOR_IG_OFF);
}

